import {
  type ChatMessageInput,
  useAiAgentConversationUpsertMutation as useGeneratedMutation,
} from '../../__codegen__/api'

export const useAiAgentConversationUpsertMutation = () => {
  const [mutate, { loading, error, data }] = useGeneratedMutation()

  const upsertConversation = async (conversationId: string, messages: ChatMessageInput[]) => {
    try {
      const response = await mutate({
        variables: {
          conversationId,
          messages,
        },
      })
      return response.data?.aiAgentConversationUpsert?.success ?? false
    } catch (error) {
      console.error('Error upserting conversation:', error)
      return false
    }
  }

  return {
    upsertConversation,
    loading,
    error,
    data,
  }
}
